/**
 * @fileoverview Axios instance — V2 API hazırlığı
 * V1'de kullanılmaz; mock data ile çalışılır.
 * V2: axiosInstance import edilerek doğrudan kullanılır.
 */

import axios from 'axios'
import { ENV } from './env'
import { clearAdminSession, getAdminSession } from '../features/admin/session'

/** Sondaki / tekilleştirilir; url ile birleşimde çift slash veya yanlış host-path önlenir. */
const baseURL = ENV.API_BASE_URL.replace(/\/+$/, '')

const axiosInstance = axios.create({
  baseURL: baseURL || undefined,
  timeout: 10_000,
  headers: {
    'Content-Type': 'application/json',
    'Accept':       'application/json',
  },
})

// ─── Request Interceptor ───────────────────────────────────────────────────
axiosInstance.interceptors.request.use(
  (config) => {
    const session = getAdminSession()
    if (session?.token) {
      config.headers.Authorization = `Bearer ${session.token}`
    }
    return config
  },
  (error) => Promise.reject(error)
)

// ─── Response Interceptor ──────────────────────────────────────────────────
// response.data unwrap  +  global error loglama
axiosInstance.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (ENV.IS_DEV) {
      console.error('[API Error]', {
        url:    error.config?.url,
        status: error.response?.status,
        data:   error.response?.data,
      })
    }
    if (error.response?.status === 401) {
      const reqUrl = String(error.config?.url ?? '')
      if (reqUrl.includes('admin/') && !reqUrl.includes('login.php')) {
        clearAdminSession()
        const base = (import.meta.env.BASE_URL || '/').replace(/\/$/, '')
        window.location.href = `${base}/admin/login`
      }
    }
    return Promise.reject(error)
  }
)

export default axiosInstance
